import React from "react";

export default function InputPhone({ errors, register, name }) {
  return (
    <input
      className={`form-control ${errors[name] && "is-invalid"}`}
      type="text"
      placeholder="54 9 11 1234-5678"
      name={name}
      {...register(name, {
        pattern: {
          value: /^\d{1,3}\d{9,13}$/,
          message: `El ${name} debe contener solo numeros y debe contener entre 10 y 13 caracteres`,
        },
      })}
    />
  );
}
